import React, { Component } from 'react';


class Galerias extends Component {
	componentDidMount() {
		window.startx();
	}
	render() {
		return (
			<body className="subpage">
				<div id="gal" className="row">
					<div className="column">
						<img src="./images/biblioteca/bib2.png" alt="Biblioteca1"></img>
						<img src="./images/biblioteca/bib3.png" alt="Biblioteca2"></img>
						<img src="./images/biblioteca/bib1.jpg" alt="Biblioteca3"></img>
						<img src="./images/biblioteca/bib4.png" alt="Biblioteca4"></img>
						<img src="./images/biblioteca/bib5.jpg" alt="Biblioteca5"></img>
					</div>
					<div className="column">
						<img src="./images/centrobotanico/cen1.png" alt="Botanico1"></img>
						<img src="./images/centrobotanico/cen2.png" alt="Botanico2"></img>
						<img src="./images/centrobotanico/cen3.png" alt="Botanico3"></img>
						<img src="./images/centrobotanico/cen4.png" alt="Botanico4"></img>
						<img src="./images/dinoparque/din1.png" alt="Botanico5"></img>
					</div>
					<div className="column">
						<img src="./images/dinoparque/din2.png" alt="Dinoparque1"></img>
						<img src="./images/dinoparque/din3.png" alt="Dinoparque2"></img>
						<img src="./images/dinoparque/din4.png" alt="Dinoparque3"></img>
						<img src="./images/dinoparque/din5.png" alt="Dinoparque4"></img>
						<img src="./images/dinoparque/din6.png" alt="Dinoparque5"></img>
					</div>
					<div className="column">
						<img src="./images/exposiciones/exp1.png" alt="Exposiciones1"></img>
						<img src="./images/exposiciones/exp2.png" alt="Exposiciones2"></img>
						<img src="./images/exposiciones/exp3.png" alt="Exposiciones3"></img>
						<img src="./images/exposiciones/exp4.png" alt="Exposiciones4"></img>
						<img src="./images/exposiciones/exp5.png" alt="Exposiciones5"></img>
					</div>
				</div>

				<div className="preview">
					<div className="content">
						<div className="close">
							<i className="fa fa-times" aria-hidden="true"></i>
						</div>
					</div>
				</div>
			</body>

		);
	}
}

export default Galerias;